export default __webpack_public_path__ + "static/fb1dafbaf48ca10966d14908f2013346.png";